<template>
  <div>
    <!-- Diamond Item (Commented Out) -->
    <!--
    <div class="gift-item diamonds">
       <svg class="gem-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
          <path d="M378.7 32H133.3L256 182.7L378.7 32zM512 192l-107.4-141.3L289.6 192H512zM222.4 192L107.4 50.67L0 192h222.4zM256 218.7L133.3 384h245.4L256 218.7zM128.4 416H0L153.6 224L128.4 416zM358.4 224L512 416h-128.4L358.4 224z"/>
        </svg>
       <div class="diamond-text-content">
          <span class="amount">10K</span>
          <span class="label">DIAMOND</span>
          <span class="price">₺78,99</span>
       </div>
    </div>-->

    <!-- Mobile Version -->
    <div class="quick-gift-bar quick-gift-bar-mobile">
      <div 
        v-for="gift in gifts"
        :key="gift.productId + '-mobile'" 
        class="gift-item"
        @click="selectGift(gift)"
      >
        <div class="gift-image-wrapper">
           <img :src="getGiftImageUrl(gift.image)" :alt="gift.label || 'Gift'" />
        </div>
        <span class="amount">{{ formatGiftCredits(gift.credits) }}</span>
      </div>
    </div>

    <!-- Desktop Version -->
    <div class="quick-gift-bar quick-gift-bar-desktop">
       <div 
        v-for="gift in gifts"
        :key="gift.productId + '-desktop'" 
        class="gift-item"
        @click="selectGift(gift)"
      >
        <div class="gift-image-wrapper">
           <img :src="getGiftImageUrl(gift.image)" :alt="gift.label || 'Gift'" />
        </div>
        <span class="amount">{{ formatGiftCredits(gift.credits) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// Remove the import as the helper doesn't exist or isn't exported
// import { formatCredits } from '@/helpers/helpers'; 

export default {
  name: 'QuickGiftBar',
  props: {
    gifts: {
      type: Array,
      default: () => [],
    }
  },
  methods: {
    // Implement formatting logic directly here
    formatGiftCredits(credits) {
      const num = Number(credits);
      if (isNaN(num)) {
        return '0'; // Handle invalid input
      }
      if (num >= 1000000) {
        // Format as million (e.g., 1.2M)
        return (num / 1000000).toFixed(1).replace('.0', '') + 'M';
      }
      if (num >= 1000) {
        // Format as thousand (e.g., 10K, 123K)
        return (num / 1000).toFixed(1).replace('.0', '') + 'K'; 
      }
      return num.toString(); // Return as is if less than 1000
    },
    getGiftImageUrl(imageName) {
        // Basic image resolver (might need refinement based on actual image names)
        if (!imageName) return '';
        const baseName = imageName.split('.')[0];
        try {
            // Prioritize png, then svg, then other common types if necessary
            return require(`@/assets/images/gifts/${baseName}.png`);
        } catch (e) {
            try {
              return require(`@/assets/images/gifts/${baseName}.svg`);
            } catch (e2) {
               console.warn(`QuickGiftBar: Could not load image for ${imageName}`);
               return ''; // Return empty string or placeholder
            }
        }
    },
    selectGift(gift) {
      // Emit an event upwards with the selected gift object
      this.$emit('send-gift', gift); 
    }
  }
}
</script>

<style lang="scss" scoped>
.quick-gift-bar {
  padding: 8px 12px;
  gap: 10px;
}

.quick-gift-bar-mobile {
  display: flex;
  overflow-x: auto;
  // Hide scrollbar visually but keep functionality
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
  }
}

.quick-gift-bar-desktop {
  display: none; // Hide desktop on mobile by default
}

.gift-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  min-width: 45px;

  .gift-image-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 4px;
    border: 1px solid rgba(255, 255, 255, 0.1);

    img {
      max-width: 65%;
      max-height: 65%;
      object-fit: contain;
    }
  }

  .amount {
    font-size: 12px;
    font-weight: 600;
    color: white;
  }
  
  // Special styling for the diamond item
  &.diamonds {
    flex-direction: row;
    align-items: center;
    background-color: #4a4a4a;
    border-radius: 25px;
    padding: 4px 10px;
    min-width: 110px;
    gap: 8px;
    cursor: default;

    .gem-svg {
        width: 28px;
        height: 28px;
        color: white;
        flex-shrink: 0;
    }
    
    .diamond-text-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0;
    }

    .amount {
        font-size: 14px;
        line-height: 1.2;
    }
    .label {
        font-size: 10px;
        color: rgba(255, 255, 255, 0.7);
        font-weight: 500;
        line-height: 1.1;
    }
    .price {
        font-size: 11px;
        color: #10d876;
        font-weight: 600;
        margin-top: 2px;
        line-height: 1.1;
    }
  }
}
</style> 